<template>
  <div class="animated fadeIn">
    <div class="row col-md-12">
      <Forms
        class="col-md-9"
        ref="frmGroup"
        :title="'CADASTRO DE LISTA DE CONTATO'"
        :showClearButton="true"
        :showSaveButton="true"
        :showBackButton="true"
        :isModal="isModal"
        v-on:Clear="onClear"
        v-on:Back="onBack"
        v-on:Save="onSave"
      >
        <div class="form-group row">
          <div class="col-12">
            <label>
              <small
                v-show="form.nome.required"
                class="text-danger"
              >*</small> Lista:
            </label>
            <div class="input-group">
              <b-form-input
                type="text"
                :placeholder="'Digite o Nome da Lista'"
                v-model="form.nome.value"
                :size="form.nome.maxlength"
                :required="form.nome.required"
                :state="form.nome.state"
              ></b-form-input>
            </div>
          </div>
        </div>
      </Forms>

      <div
        class="d-flex flex-row flex-wrap col-md-3 side__bar"
        style="padding-right: 0"
      >
        <b-card id="side-menu" header="Ações" class="text-center w-100">
          <b-card-text>
            <b-button-group class="w-100" vertical>
              <b-button
                class="side-menu__links"
                :disabled="data.id ? false : true"
                squared
                variant="outline-primary"
                @click="openAttListaInteligente"
              >
                <i class="fas fa-undo"></i> Atualizar Lista
                <i v-if="checkRecorrenciaAtt()" class="fas fa-clock"></i>
              </b-button>
              <b-button
                class="side-menu__links"
                :disabled="data.id ? false : true"
                squared
                variant="outline-primary"
                @click="openAcaoExportarExcel"
              >
                <i class="fas fa-file-export"></i> Exportar Excel
              </b-button>
              <b-button
                class="side-menu__links"
                :disabled="data.id ? false : true"
                squared
                variant="outline-primary"
                @click="openAcaoAbrirCardModal"
              >
                <i class="fas fa-plus"></i> Abrir Card
                <i v-if="checkRecorrenciaOpenCard()" class="fas fa-clock"></i>
              </b-button>
              <b-button
                class="side-menu__links"
                :disabled="data.id ? false : true"
                squared
                variant="outline-primary"
                @click="openCreateCampanhaListaModal"
              >
               <i class="fas fa-list"></i> Criar Lista Campanha
               <i v-if="checkRecorrenciaCampanha()" class="fas fa-clock"></i>
              </b-button>
              <b-button
                class="side-menu__links"
                :disabled="data.id ? false : true"
                squared
                variant="outline-primary"
                @click="openSendWhatsAppListaModal"
              >
                <i class="fab fa-whatsapp"></i> Enviar WhatsApp
               <i v-if="checkRecorrenciaSendWhatsApp()" class="fas fa-clock"></i>
              </b-button>
              <b-button
                v-show="classeA"
                class="side-menu__links"
                :disabled="data.id ? false : true"
                squared
                variant="outline-primary"
                @click="openSendSmsListaModal"
              >
                <i class="fas fa-sms"></i> Enviar SMS
              </b-button>
              <b-button
                class="side-menu__links"
                :disabled="data.id ? false : true"
                squared
                variant="outline-primary"
                @click="openSendEmailListaModal"
              >
                <i class="far fa-envelope"></i> Enviar E-mail
               <i v-if="checkRecorrenciaSendEmail()" class="fas fa-clock"></i>
              </b-button>
            </b-button-group>
          </b-card-text>
        </b-card>
      </div>
    </div>

    <AcaoListaInteligenteGrid ref="AcaoListaInteligenteGrid" />
    <ContatosGrid ref="ContatosAtivoGrid" :key="'ativo-' + (data.id || 0)" :titulo="'Contatos Ativos'" :listaInteligenteData="this.data" @triggerClasseA="hasClasseA" @hasObjList="hasObjList" @inactive="onLoadContatos" />
    <ContatosGrid ref="ContatosInativoGrid" :key="'inativo-' + (data.id || 0)" :titulo="'Contatos inativos'" :isInactiveGrid="true" :listaInteligenteData="this.data" @inactive="onLoadContatos" />

    <div class="row">
      <div class="col-md-12 pl-4">
        <button
          type="button"
          class="btn btn-third btn-sm"
          :disabled="!canAddContact"
          @click="onOpenAdvancedContactAdd"
          v-b-tooltip.hover
          :title="'Adicionar Contatos de forma avançado na Lista'"
        >
          <i class="fas fa-user-plus"></i>
          <span class="d-md-down-none"> Adicionar Avançado</span>
        </button>
        <button
          v-if="contatosObjList"
          type="button"
          class="btn btn-danger btn-sm"
          :disabled="!canAddContact"
          @click="onDeleteContacts"
          v-b-tooltip.hover
          :title="'Limpar todos os contatos da lista'"
        >
          <i class="fas fa-user-minus"></i>
          <span class="d-md-down-none"> Limpar Contatos na Lista</span>
        </button>
      </div>
    </div>

    <ModalListaContatoAdvancedSearch ref="ModalListaContatoAdvancedSearch" @created="onLoadContatos" />
    <OpenCardModal ref="OpenCardModal" @reloadAcoes="emitLoadAcoes" />
    <CreateCampanhaListaModal ref="CreateCampanhaListaModal" @reloadAcoes="emitLoadAcoes" />
    <SendEmailListaInteligenteModal ref="SendEmailListaInteligenteModal" @reloadAcoes="emitLoadAcoes" />
    <SendSmsListaInteligenteModal ref="SendSmsListaInteligenteModal" @reloadAcoes="emitLoadAcoes" />
    <SendWhatsappListaInteligenteModal ref="SendWhatsappListaInteligenteModal" @reloadAcoes="emitLoadAcoes" />
    <SendExcelEmailConfirmationModal ref="SendExcelEmailConfirmationModal" @reloadAcoes="emitLoadAcoes" />
    <AttlistaInteligenteModal ref="AttlistaInteligenteModal" @reloadAcoes="emitLoadAcoes" />
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import ListaInteligenteRepository from '@/shared/http/repositories/configurations/listainteligente.js'
import RecorrenciaListaInteligenteRepository from '@/shared/http/repositories/configurations/recorrenciaListaInteligente.js'

import ModalListaContatoAdvancedSearch from '@/components/forms/ModalListaContatoAdvancedSearch.vue'
import AcaoListaInteligenteGrid from '@/views/private/configurations/lista-inteligente/components/add/grids/AcaoListaInteligenteGrid.vue'
import SendExcelEmailConfirmationModal from './modal/SendExcelEmailConfirmationModal.vue'
import OpenCardModal from './modal/OpenCardModal.vue'
import CreateCampanhaListaModal from './modal/CreateCampanhaListaModal.vue'
import SendEmailListaInteligenteModal from './modal/SendEmailListaInteligenteModal.vue'
import SendSmsListaInteligenteModal from './modal/SendSmsListaInteligenteModal.vue'
import SendWhatsappListaInteligenteModal from './modal/SendWhatsappListaInteligenteModal.vue'
import ContatosGrid from './grids/ContatosGrid.vue'
import ParametroClasseA from '../../../../../../shared/http/repositories/configurations/parametroClasseA'
import AttlistaInteligenteModal from './modal/AttListaInteligenteModal.vue'

const ListaInteligenteData = {
  id: null,
  nome: null
}

const ListaInteligenteForm = {
  nome: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  }
}

export default {
  name: 'ListaInteligenteAdd',
  mixins: [ActionsForm],
  props: {
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: ListaInteligenteData,
      form: ListaInteligenteForm,
      canAddContact: false,
      classeA: true,
      contatosObjList: false,
      recorrencia: []
    }
  },
  components: {
    AttlistaInteligenteModal,
    ContatosGrid,
    AcaoListaInteligenteGrid,
    ModalListaContatoAdvancedSearch,
    SendExcelEmailConfirmationModal,
    OpenCardModal,
    CreateCampanhaListaModal,
    SendEmailListaInteligenteModal,
    SendSmsListaInteligenteModal,
    SendWhatsappListaInteligenteModal
  },
  watch: {
    'data.id': function (newId) {
      if (newId) {
        this.getRecorrencia()
      }
    }
  },

  methods: {
    onBack () {
      this.$emit('Back')
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      this.canAddContact = false
      this.data.id = null

      if (this.$refs.alert) {
        this.$refs.alert.Close()
      }
    },
    onEdit (obj) {
      loading.push()
      if (obj && obj.id) {
        Tools.SetValueInForm(this.form, this.data, obj)
        this.canAddContact = true

        this.$refs.AcaoListaInteligenteGrid.onLoadAcoes(obj.id)

        // Carrega os contatos
        this.$nextTick(() => {
          this.onLoadContatos()
        })

        loading.pop()
      }
      loading.pop()
    },
    onCreate () {
      loading.push()
      this.data.nome = this.form.nome.value

      ListaInteligenteRepository.Create(this.data)
        .then((response) => {
          loading.close()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onEdit(response.data)
        })
        .catch(this.handleDuplicateEntryException)
    },
    openAttListaInteligente () {
      this.$nextTick(() => {
        this.$refs['AttlistaInteligenteModal'].openConfirmationModal(this.data.id)
      })
    },
    openAcaoExportarExcel () {
      this.$nextTick(() => {
        this.$refs['SendExcelEmailConfirmationModal'].openConfirmationModal(this.data.id)
      })
    },
    openAcaoAbrirCardModal () {
      this.$nextTick(() => {
        this.$refs['OpenCardModal'].showModal(this.data.id)
      })
    },
    openCreateCampanhaListaModal () {
      this.$nextTick(() => {
        this.$refs['CreateCampanhaListaModal'].showModal(this.data.id)
      })
    },
    openSendEmailListaModal () {
      this.$nextTick(() => {
        this.$refs['SendEmailListaInteligenteModal'].showModal(this.data.id)
      })
    },
    openSendSmsListaModal () {
      this.$nextTick(() => {
        this.$refs['SendSmsListaInteligenteModal'].showModal(this.data.id)
      })
    },
    openSendWhatsAppListaModal () {
      this.$nextTick(() => {
        this.$refs['SendWhatsappListaInteligenteModal'].showModal(this.data.id)
      })
    },
    emitLoadAcoes () {
      this.$refs.AcaoListaInteligenteGrid.onLoadAcoes(this.data.id)
      this.getRecorrencia()
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      this.data.nome = this.form.nome.value
      ListaInteligenteRepository.Update(this.data)
        .then((response) => {
          loading.close()
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onDeleteContacts () {
      loading.push()
      ListaInteligenteRepository.DeleteList(this.data.id)
        .then((response) => {
          loading.close()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoadContatos()
        })
        .catch(this.onException)
    },
    onOpenContactAdd () {
      this.$refs.ModalListaContatoAdvancedSearch.showModal(this.data.id)
    },
    onOpenAdvancedContactAdd () {
      this.$refs.ModalListaContatoAdvancedSearch.showModal(this.data.id)
    },
    onOpenUpload () {
      this.$refs.ModalListaContatoAdvancedSearch.showModal(this.data.id)
    },
    hasClasseA () {
      ParametroClasseA.GetAll()
        .then(response => {
          if (!response.data || !response.data.usuario) {
            this.classeA = false
          }
        })
    },
    hasObjList () {
      this.contatosObjList = true
    },
    onLoadContatos () {
      // Só carrega se tiver ID
      if (!this.data || !this.data.id) {
        return
      }

      // CORREÇÃO: Usa recarregarDoZero() ao invés de onLoad()
      // Isso reseta a paginação para página 1 após adicionar novos contatos
      if (this.$refs['ContatosAtivoGrid']) {
        this.$refs['ContatosAtivoGrid'].recarregarDoZero()
      }

      if (this.$refs['ContatosInativoGrid']) {
        this.$refs['ContatosInativoGrid'].recarregarDoZero()
      }
    },
    getRecorrencia () {
      this.id = this.data.id
      RecorrenciaListaInteligenteRepository.GetById(this.id)
        .then((response) => {
          if (response.status === 200) {
            this.recorrencia = response.data.content
          }
        })
        .catch((error) => {
          console.error('Erro ao criar recorrência:', error)
        })
    },
    checkRecorrenciaAtt () {
      return this.recorrencia.some(
        (item) => item.acaoListaInteligente === 'ATT_LISTA_INTELIGENTE' && item.status === true
      )
    },
    checkRecorrenciaOpenCard () {
      return this.recorrencia.some(
        (item) => item.acaoListaInteligente === 'OPEN_CARD' && item.status === true
      )
    },
    checkRecorrenciaCampanha () {
      return this.recorrencia.some(
        (item) => item.acaoListaInteligente === 'CREATE_LIST_CAMPAIGN' && item.status === true
      )
    },
    checkRecorrenciaSendEmail () {
      return this.recorrencia.some(
        (item) => item.acaoListaInteligente === 'SEND_EMAIL' && item.status === true
      )
    },
    checkRecorrenciaSendWhatsApp () {
      return this.recorrencia.some(
        (item) => item.acaoListaInteligente === 'SEND_WHATSAPP' && item.status === true
      )
    }

  }
}
</script>

<style scoped lang="scss">
#side-menu {
  height: fit-content;

  .card-header {
    color: white;
    background: linear-gradient(90deg, #2dce89, #2dcecc);
  }

  .card-body {
    height: fit-content;
  }
}

.btn.side-menu__links.btn-outline-primary {
  border: 1px solid #cfd8dc;
  color: #04a791;
  text-align: left;

  &:hover {
    background: #04a791;
    color: white;
  }
}

.side__bar {
  @media screen and (max-width:900px) {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/add/ListaInteligenteAdd.vue